import Box from '@mui/material/Box';
import MyContact from './contents/MyContact';
import HomePage from './contents/Products';
import Blogs from './contents/Blogs';

const MainContent = () => {

    return <Box id="Home" className="container">
        <HomePage />
        {/* <MyWorkTour />
        <MyProjects /> */}
        <Blogs />
        <MyContact />
    </Box>
}

export default MainContent;
